/**
 * Cryptographically secure replacements for Math.random(). Sonar (S2245) flags
 * Math.random() wherever its output ends up in an id/code/password, since it's
 * predictable; these use the Web Crypto API instead.
 */

/** Drop-in replacement for Math.random(): a float in [0, 1). */
export function secureRandomFloat(): number {
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  return buf[0] / 2 ** 32;
}

/** Random integer in [min, max). */
export function secureRandomInt(min: number, max: number): number {
  return Math.floor(secureRandomFloat() * (max - min)) + min;
}

/** Random lowercase-alphanumeric string, e.g. for ids/keys. */
export function secureRandomAlphanumeric(length: number): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let out = '';
  for (let i = 0; i < length; i++) {
    out += chars[secureRandomInt(0, chars.length)];
  }
  return out;
}
